// Dream Recovery: Sticky-Kaufleiste.
// Zeigt sich, sobald der Warenkorb-Button der Produktseite nicht mehr sichtbar ist,
// und löst beim Klick genau diesen Button aus (Dawn-Warenkorb-Logik bleibt unverändert).
if (!customElements.get('dr-sticky-atc')) {
  customElements.define(
    'dr-sticky-atc',
    class DrStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-dr-sticky-button]');
        this.priceEl = this.querySelector('[data-dr-sticky-price]');
        this.mainButton = document.querySelector('product-info product-form button[type="submit"][name="add"]');
        this.button?.addEventListener('click', () => this.onClick());

        if (this.mainButton && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggle(passed);
          });
          this.observer.observe(this.mainButton);
        } else if (!this.mainButton) {
          this.toggle(true);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.onVariantChange(data.variant));
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
      }

      toggle(show) {
        this.hidden = false;
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('dr-sticky-visible', show);
      }

      onClick() {
        if (this.mainButton && !this.mainButton.disabled) {
          this.mainButton.click();
        } else {
          const target = document.querySelector('product-info') || document.querySelector('main');
          target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      onVariantChange(variant) {
        if (!variant) return;
        if (this.priceEl) {
          const currency = window.Shopify?.currency?.active || 'EUR';
          const price = new Intl.NumberFormat(document.documentElement.lang || 'de', {
            style: 'currency',
            currency,
          }).format(variant.price / 100);
          const title = variant.title && variant.title !== 'Default Title' ? `${variant.title} · ` : '';
          this.priceEl.textContent = `${title}${price}`;
        }
        if (this.button) {
          this.button.disabled = !variant.available;
          this.button.textContent = variant.available ? this.button.dataset.label : window.variantStrings?.soldOut || 'Ausverkauft';
        }
      }
    }
  );
}
